import React, { useCallback, useContext, useEffect, useState } from "react";
import { Container } from "components";
import Breadcrumb from "components/molecules/Breadcrumb";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getData, putData } from "actions";
import { API_URL_autoResponseSetting } from "constants/api";
import { autoResponseSettingReducers } from "redux/autoResponseSettingSlice";
import { AuthContext } from "context/AuthContext";
import { FaRegQuestionCircle } from "react-icons/fa";
import { Tooltip } from "react-tooltip";

const Autoresponse = () => {
  const navigate = useNavigate();
  const [adminAccess, setAdminAccess] = useState(false);
  const { datauser } = useContext(AuthContext);
  const dispatch = useDispatch();
  const [newTicket, setNewTicket] = useState("");
  const [newUser, setNewUser] = useState("");
  const [agentNewTicket, setAgentNewTicket] = useState("");

  const {
    getAutoResponseSettingResult,
    addAutoResponseSettingResult,
  } = useSelector((state) => state.autoResponseSetting);

  const get = useCallback(
    async (params) => {
      getData(
        API_URL_autoResponseSetting,
        params,
        { dispatch, redux: autoResponseSettingReducers },
        "GET_AUTORESPONSESETTING"
      );
    },
    [dispatch]
  );

  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = {
      new_ticket: newTicket,
      agent_new_ticket: agentNewTicket,
      new_user: newUser,
    };
    //edit on id 1
    putData(
      `${API_URL_autoResponseSetting}1/`,
      formData,
      { dispatch, redux: autoResponseSettingReducers },
      "ADD_AUTORESPONSESETTING",
      () => {
        fetchData();
      }
    );
  };

  const fetchData = useCallback(() => {
    //get id 1 for setting
    const params = `1/`;
    get(params);
  }, [get]);

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (addAutoResponseSettingResult) {
      fetchData();
    }
  }, [addAutoResponseSettingResult, fetchData]);

  useEffect(() => {
    if (getAutoResponseSettingResult) {
      setNewTicket(getAutoResponseSettingResult.new_ticket);
      setAgentNewTicket(getAutoResponseSettingResult.agent_new_ticket);
      setNewUser(getAutoResponseSettingResult.new_user);
    }
  }, [getAutoResponseSettingResult]);

  useEffect(() => {
    if (datauser !== "") {
      const permissionViewMenuAdmin = datauser.group_permissions.includes(
        "access_menu_admin"
      );
      if (permissionViewMenuAdmin) {
        setAdminAccess(true);
      } else {
        navigate("/dashboard/agent");
      }
    }
  }, [datauser]);

  if (!adminAccess) {
    return null;
  }

  return (
    <Container>
      <Breadcrumb
        title={"Settings"}
        excludedPaths={["tickets", "administrator"]}
        group={"Superadmin"}
      />
      <div className="bg-neutral dark:bg-neutral-800 rounded overflow-hidden shadow">
        <form onSubmit={handleSubmit}>
          <div className="h-12 w-full flex items-center px-4 bg-neutral-100 dark:bg-neutral-700 border-b border-neutral-200 dark:border-neutral-600">
            Auto Response Settings
            <span
              className="ml-4 text-blue-700"
              data-tooltip-id="my-tooltip"
              data-tooltip-content="Send notification to client by email after create ticket"
              data-tooltip-place="left"
            >
              <FaRegQuestionCircle />
            </span>
          </div>
          <div className="h-auto w-full mb-4 px-4  bg-neutral dark:bg-neutral-800  object-left">
            <label>
              <input
                id="newTicket"
                type="checkbox"
                checked={newTicket === 1}
                onChange={(e) => setNewTicket(e.target.checked ? 1 : 0)}
                className="form-checkbox mr-2 mt-4"
              />
              Notify create new ticket to user
            </label>
            <br />
            <label>
              <input
                id="newUser"
                type="checkbox"
                checked={newUser === 1}
                onChange={(e) => setNewUser(e.target.checked ? 1 : 0)}
                className="form-checkbox mr-2 mt-4"
              />
              Notify new user registration to user
            </label>
            <br />
          </div>
          <div className="h-12 w-full grid items-center px-4 bg-neutral-50 dark:bg-neutral-700 border-b border-neutral-200 dark:border-neutral-600">
            <button
              type="submit"
              className="flex w-16 items-center justify-center p-1 rounded shadow-sm border text-white bg-sky-800 hover:bg-sky-700"
            >
              Submit
            </button>
          </div>
        </form>
      </div>
      <Tooltip id="my-tooltip" />
    </Container>
  );
};

export default Autoresponse;
